<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15VK2vC/tc-custom/9780545932936.jpg?1701477035846" alt="This image is the cover for the book Dumbness Is a Dish Best Served Cold, Dear Dumb Diary"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dumbness Is a Dish Best Served Cold, Dear Dumb Diary
      </h1>
      <p class="bookDescription body article font2">
        <b>Return to Mackerel Middle School with a special full-color extra-dumb diary from the <i>New York Times</i>–bestselling author! </b><br/><br/>Life at Mackerel Middle School is as dumb as ever—but Jamie Kelly may have finally found the key to fame, fortune, and fabulousness. Together with Isabella and Angeline, she’s come up with a moneymaking idea, and it has to do with food. Everyone likes food! They’re going to be rich!<br/><br/>The only problem? They have to come up with something that people actually want to eat.<br/><br/>Jamie has some sophisticated thoughts on food, like, “She was manipulating us like dough. Like the sweet, delicious dough that we are. And she was baking us into the type of delicious cookies you can only get from dough like us. And she was putting sprinkles of us on top of us, and—forget it. I’m hungry. I want some cookies.”<br/><br/>This is sure to go well.<br/><br/><b>Praise for Jim Benton’s books</b><br/><br/>“An amusing antic sensibility.” —<i>Publishers Weekly</i><br/><br/>“Preteens will be onboard immediately.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Benton
      </h2>
      
      <p class="authorDescription body article"> Jim Benton is an award-winning author and artist. You may know some of the other things he's made, like It's Happy Bunny, Dear Dumb Diary, Franny K. Stein, Victor Shmud, and more. He's created a TV series, written books, and produced a movie, and he always did everything his parents told him to do. Pretty much. Jim lives in Michigan with his wife and kids and can be found online at jimbenton.com. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      SCHOLASTIC INC.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3fe1ba66